export default {
  进入企业云展: '进入企业云展',
  暂无相关的产业头条: '暂无相关的产业头条',
  作者: '作者',
  分类: '分类',
  发布时间: '发布时间',
  阅读数: '阅读数',
  非原创: '非原创',
  转载于: '转载于',
  凡本网注明来源: '*凡本网注明来源：“云展动力”的所有作品,版权均属于云展动力,转载请注明。',
  凡注明为其它来源的信息:
    '*凡注明为其它来源的信息,均为平台注册会员所发布,发布目的在于传递更多信息,并不代表云展动力赞同其观点及对其真实性负责,若涉及到版权问题,请联系云展动力进行沟通删除。',
  该头条已下架: '该头条已下架',
  该头条不存在: '该头条不存在',
}
